import {
  useReducedMotion,
  type TargetAndTransition,
  type Transition
} from "motion/react";

const EASE = [0.4, 0, 0.2, 1] as const;

export type AuthMotionPreset = {
  initial: TargetAndTransition;
  animate: TargetAndTransition;
  exit: TargetAndTransition;
  transition: Transition;
};

export type AuthMotion = {
  /** Content grows in from zero height; used for steps unfolding beneath the email. */
  unfold: AuthMotionPreset;
  /** Plain opacity crossfade; used for copy and label actions swapping in place. */
  fade: AuthMotionPreset;
};

/** Motion presets shared by the sign-in card. Durations collapse under reduced motion. */
export function useAuthMotion(): AuthMotion {
  const reduceMotion = useReducedMotion();
  return {
    unfold: {
      initial: { height: 0, opacity: 0 },
      animate: { height: "auto", opacity: 1 },
      exit: { height: 0, opacity: 0 },
      transition: { duration: reduceMotion ? 0 : 0.3, ease: [...EASE] }
    },
    fade: {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
      transition: { duration: reduceMotion ? 0 : 0.15 }
    }
  };
}
